<template>
    <section id="form_section">
        <div class="container">
            <div class="content_header_container">
                <h1 class="content_header_title">Крос-референс, підбір аналогів електротехнічної продукції</h1>
                <p class="content_header_subtitle">Введіть артикул або найменування товару для пошуку аналогів у нашому каталозі</p>
            </div>

            <div class="form_group">
                <label class="form_label">Пошук аналога</label>
                <div class="input_row">
                    <input class="form_input" placeholder="Введіть дані товару для пошуку" v-model="search_text" type="text" />
                    <button type="button" :disabled="!search_text" class="btn btn-primary" style="width: 120px;" @click="search()">
                        <span v-if="loading">AI аналіз..</span>
                        <span v-else>Знайти</span>
                    </button>
                </div>
            </div>

            <div v-if="result && result.error" class="alert alert-danger mt-3" role="alert">
                {{ result.error }}
            </div>
            <div v-else-if="result && result.message" class="alert alert-danger mt-3" role="alert">
                {{ result.message }}
            </div>

            <div v-else-if="result && result.product && !result.analogs.length" class="mt-3">
                <h1 class="text-xl font-bold mb-4">Результати пошуку</h1>
                <p class="m-0">Схоже, ви шукаєте: </p>
                <table class="min-w-full bg-white border rounded">
                    <thead>
                        <tr class="bg-gray-100">
                            <th colspan="3" class="px-4 py-2 text-left text-sm font-bold text-gray-700 border-b">Ваш запит</th>
                        </tr>
                        <tr>
                            <th class="px-4 py-2 border">Артикул</th>
                            <th class="px-4 py-2 border">Назва</th>
                            <th class="px-4 py-2 border">Характеристики</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="hover:bg-gray-100">
                        <td class="px-4 py-2 border">{{ result.product.article }}</td>
                        <td class="px-4 py-2 border">{{ result.product.name }}</td>
                        <td class="px-4 py-2 border">
                            <ul v-if="result.product.characteristics">
                                <li v-for="char in result.product.characteristics" :key="char.name">
                                    {{ char.name }}: {{ char.value }} {{ char.unit }}
                                </li>
                            </ul>
                        </td>
                        </tr>
                    </tbody>
                </table>
                <div class="d-flex gap-1 justify-content-end pt-3">
                    <button type="button" :disabled="loading" class="btn btn-primary" style="width: 120px;" @click="getAnalogs()">
                        <span v-if="loading">AI аналіз..</span>
                        <span v-else>Так, вірно</span>
                    </button>
                    <button type="button" :disabled="loading" class="btn btn-secondary" style="width: auto;" @click="() => { result = null }">
                        <span>Ні, я шукаю інше</span>
                    </button>
                </div>
            </div>

            <div v-else-if="result && result.analogs" class="mt-3">
                <h1 class="text-xl font-bold mb-4">Результати пошуку</h1>
                <table class="min-w-full bg-white border rounded">
                    <thead>
                        <tr class="bg-gray-100">
                            <th colspan="3" class="px-4 py-2 text-left text-sm font-bold text-gray-700 border-b">Ваш запит</th>
                        </tr>
                        <tr>
                            <th class="px-4 py-2 border">Артикул</th>
                            <th class="px-4 py-2 border">Назва</th>
                            <th class="px-4 py-2 border">Характеристики</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="hover:bg-gray-100">
                        <td class="px-4 py-2 border">{{ result.product.article }}</td>
                        <td class="px-4 py-2 border">{{ result.product.name }}</td>
                        <td class="px-4 py-2 border">
                            <ul v-if="result.product.characteristics">
                                <li v-for="char in result.product.characteristics" :key="char.name">
                                    {{ char.name }}: {{ char.value }} {{ char.unit }}
                                </li>
                            </ul>
                        </td>
                        </tr>
                    </tbody>
                </table>
                <table class="min-w-full bg-white border rounded">
                    <thead>
                        <tr class="bg-gray-100">
                            <th colspan="6" class="px-4 py-2 text-left text-sm font-bold text-gray-700 border-b">Аналоги</th>
                        </tr>
                        <tr>
                            <th class="px-4 py-2 border">Артикул</th>
                            <th class="px-4 py-2 border">Назва</th>
                            <th class="px-4 py-2 border">Бренд</th>
                            <th class="px-4 py-2 border">Наявність</th>
                            <th class="px-4 py-2 border">Ціна, грн з ПДВ</th>
                            <th class="px-4 py-2 border">Характеристики</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in result.analogs" :key="item.article" class="hover:bg-gray-100">
                        <td class="px-4 py-2 border">{{ item.article }}</td>
                        <td class="px-4 py-2 border"><a :href="item.tech_char" target="_blank">{{ item.name }}</a></td>
                        <td class="px-4 py-2 border">{{ item.brand ? item.brand.value : '' }}</td>
                        <td class="px-4 py-2 border">{{ item.balance }}</td>
                        <td class="px-4 py-2 border">{{ item.price }}</td>
                        <td class="px-4 py-2 border">
                            <ul v-if="item.characteristics">
                                <template v-for="char in item.characteristics" :key="char.title">
                                    <li v-if="char.title !== 'Бренд'">
                                        {{ char.title }}: {{ char.value }} {{ char.unit }}
                                    </li>
                                </template>
                            </ul>
                        </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </section>
</template>

<script>
import axios from "axios";
import CommonLayout from "@/Layouts/CommonLayout";
import "bootstrap/dist/css/bootstrap.min.css";

export default {
    layout: CommonLayout,
    components: {

    },
    data() {
        return {
            search_text: null,
            result: null,
            loading: false,
        }
    },
    methods: {
        search() {
            if (this.loading) {
                alert('Зачекайте...');
                return false
            }

            this.loading = true
            axios.post(this.route('api.analogs.search'), {
                search_text: this.search_text,
            })
            .then((result) => {
                this.result = result.data.result
                this.loading = false
            }).catch((error) => {
                this.loading = false
                console.log(error);
                window.scroll(0, 0);
            })
        },
        getAnalogs() {
            if (this.loading) {
                alert('Зачекайте...');
                return false
            }

            this.loading = true
            axios.post(this.route('api.analogs.get'), {
                search_text: this.search_text,
                result: this.result,
            })
            .then((result) => {
                this.result = result.data.result
                this.loading = false
            }).catch((error) => {
                this.loading = false
                console.log(error);
                window.scroll(0, 0);
            })
        }
    }
}
</script>

<style scoped>
.container {
    padding: 80px 25px 0 20px;
}
.content_header_title {
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    line-height: 43px;
    color: #212529;
}
.content_header_subtitle {
    color: #525252;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    margin-bottom: 20px;
}
#form_section {
    max-width: 1296px;
    margin: 0 auto;
}

.content_header_container {
    padding-bottom: 50px;
}

@media (max-width: 780px) {
    .container {
        padding: 50px 0 0 0;
    }
    .content_header_container {
        flex-direction: column;
    }
}

.commercial_offer_order_btn {
    border-radius: 4px;
    background: #356EEF;
    width: 282px;
    height: 48px;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
}
.commercial_offer_order_btn.disabled {
    background: #CED4DA;
}
.form_group {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
}
.form_label {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    display: flex;
    align-items: center;
}

.form_input {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    padding: 10px 16px;
    background: #FFFFFF;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    width: 100%;
}
.input_row {
    display: flex;
    gap: 10px;
}

a.disabled {
    cursor:not-allowed;
    filter: opacity(0.5);
}

.result {
    border-radius: 20px;
    background-color: #c6c6c9;
    padding: 20px;
    margin-top: 20px;
}

table {
  border-collapse: collapse;
  width: 100%;
}
th, td {
  text-align: left;
}
</style>
